<template>
  <div class="assistente" :class="{ 'assistente--deslocado': isRevenda }">
    <v-scale-transition origin="bottom right">
      <v-card v-show="aberto" class="assistente-painel" elevation="12">
        <div class="assistente-cabecalho">
          <v-avatar color="white" size="34" class="mr-3">
            <v-icon color="blue darken-2">mdi-robot-happy-outline</v-icon>
          </v-avatar>

          <div class="assistente-cabecalho-texto">
            <span class="assistente-titulo">Assistente</span>
            <span class="assistente-subtitulo">Tire suas dúvidas sobre o sistema</span>
          </div>

          <v-spacer></v-spacer>

          <v-btn icon dark small class="ml-1" @click="aberto = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="assistente-corpo" ref="corpo">
          <div v-if="!mensagens.length" class="assistente-vazio">
            <v-icon color="blue lighten-2" size="46">mdi-chat-question-outline</v-icon>
            <p class="assistente-vazio-titulo">Olá! Como posso ajudar?</p>
            <p class="assistente-vazio-texto">
              Escreva sua dúvida abaixo ou escolha um dos assuntos:
            </p>

            <v-chip v-for="sugestao in sugestoes" :key="sugestao" class="ma-1" small outlined color="blue darken-2"
              @click="enviarSugestao(sugestao)">
              {{ sugestao }}
            </v-chip>
          </div>

          <div v-for="(mensagem, indice) in mensagens" :key="indice" class="assistente-mensagem"
            :class="`assistente-mensagem--${mensagem.tipo}`">
            <div v-if="mensagem.tipo === 'usuario'" class="assistente-balao assistente-balao--usuario">
              {{ mensagem.texto }}
            </div>

            <div v-else-if="mensagem.tipo === 'erro'" class="assistente-balao assistente-balao--erro">
              <v-icon small color="red darken-2" class="mr-1">mdi-alert-circle-outline</v-icon>
              {{ mensagem.texto }}
            </div>

            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-else class="assistente-balao assistente-balao--assistente md-conteudo" v-html="mensagem.html">
            </div>
          </div>

          <div v-if="carregando" class="assistente-mensagem assistente-mensagem--assistente">
            <div class="assistente-balao assistente-balao--assistente assistente-digitando">
              <span></span><span></span><span></span>
            </div>
          </div>
        </div>

        <div class="assistente-rodape">
          <v-textarea v-model="pergunta" ref="campo" placeholder="Escreva sua dúvida..." rows="1" auto-grow no-resize
            hide-details dense outlined :disabled="carregando" @keydown.enter.exact.prevent="perguntar()">
          </v-textarea>

          <v-btn icon color="blue darken-2" class="ml-2" :loading="carregando" :disabled="!pergunta.trim()"
            @click="perguntar()">
            <v-icon>mdi-send</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-scale-transition>

    <v-btn class="assistente-fab" color="blue darken-2" dark fab small aria-label="Fale com o assistente"
      @click="alternar()">
      <v-icon size="20">{{ aberto ? 'mdi-close' : 'mdi-robot-happy-outline' }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { questionarTutorial } from '../../services/api'
import { markdownParaHtml } from '../../utils/markdown'

export default {
  name: 'Assistente',
  data() {
    return {
      aberto: false,
      carregando: false,
      pergunta: '',
      mensagens: [],
      sugestoes: [
        'Como cadastrar um produto?',
        'Como configurar as formas de pagamento?',
        'Como emitir nota fiscal?',
        'Como integrar com o iFood?',
      ],
    }
  },
  methods: {
    alternar() {
      this.aberto = !this.aberto

      if (this.aberto) {
        this.$nextTick(() => {
          this.rolarParaFim()
          this.focarCampo()
        })
      }
    },
    enviarSugestao(sugestao) {
      this.pergunta = sugestao
      this.perguntar()
    },
    focarCampo() {
      this.$refs.campo?.focus()
    },
    rolarParaFim() {
      const corpo = this.$refs.corpo
      if (corpo) {
        corpo.scrollTop = corpo.scrollHeight
      }
    },
    responder(mensagem) {
      this.mensagens.push(mensagem)
      this.$nextTick(this.rolarParaFim)
    },
    perguntar() {
      const assunto = this.pergunta.trim()

      if (!assunto || this.carregando) {
        return
      }

      const token = localStorage.getItem('token')
      if (!token) {
        this.responder({
          tipo: 'erro',
          texto: 'Sua sessão expirou. Entre novamente para usar o assistente.',
        })
        return
      }

      this.responder({ tipo: 'usuario', texto: assunto })
      this.pergunta = ''
      this.carregando = true
      this.$nextTick(this.rolarParaFim)

      questionarTutorial(token, assunto)
        .then((response) => {
          const dados = response?.data
          this.responder({ tipo: 'assistente', html: markdownParaHtml(dados) })
        })
        .catch((error) => {
          this.responder({
            tipo: 'erro',
            texto: error?.response?.data?.message || 'Não foi possível falar com o assistente. Tente novamente em instantes.',
          })
        })
        .then(() => {
          this.carregando = false
          this.$nextTick(() => {
            this.rolarParaFim()
            this.focarCampo()
          })
        })
    },
  },
}
</script>

<style scoped>
.assistente {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 7;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

/* Nas revendas o widget de atendimento ocupa o canto inferior direito. */
.assistente--deslocado {
  bottom: 104px;
}

.assistente-fab {
  align-self: flex-end;
}

.assistente-painel {
  display: flex;
  flex-direction: column;
  width: 390px;
  max-width: calc(100vw - 32px);
  height: 560px;
  max-height: calc(100vh - 180px);
  margin-bottom: 12px;
  border-radius: 12px !important;
  overflow: hidden;
}

.assistente-cabecalho {
  display: flex;
  align-items: center;
  padding: 12px 12px 12px 16px;
  background-color: #1976d2;
  color: #fff;
}

.assistente-cabecalho-texto {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  min-width: 0;
}

.assistente-titulo {
  font-size: 15px;
  font-weight: 700;
}

.assistente-subtitulo {
  font-size: 11px;
  opacity: 0.85;
}

.assistente-corpo {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 14px;
  background-color: #f5f7fa;
}

.assistente-vazio {
  text-align: center;
  padding: 18px 6px;
}

.assistente-vazio-titulo {
  margin: 10px 0 2px;
  font-weight: 700;
  color: #37474f;
}

.assistente-vazio-texto {
  margin-bottom: 10px;
  font-size: 13px;
  color: #78909c;
}

.assistente-mensagem {
  display: flex;
  margin-bottom: 10px;
}

.assistente-mensagem--usuario {
  justify-content: flex-end;
}

.assistente-balao {
  max-width: 92%;
  padding: 10px 12px;
  border-radius: 12px;
  font-size: 13.5px;
  line-height: 1.5;
  word-break: break-word;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

.assistente-balao--usuario {
  background-color: #1976d2;
  color: #fff;
  border-bottom-right-radius: 2px;
  white-space: pre-wrap;
}

.assistente-balao--assistente {
  background-color: #fff;
  color: #37474f;
  border-bottom-left-radius: 2px;
}

.assistente-balao--erro {
  background-color: #ffebee;
  color: #c62828;
  border-bottom-left-radius: 2px;
}

.assistente-digitando {
  display: flex;
  align-items: center;
}

.assistente-digitando span {
  width: 6px;
  height: 6px;
  margin: 0 2px;
  border-radius: 50%;
  background-color: #90a4ae;
  animation: assistente-pulso 1.2s infinite ease-in-out;
}

.assistente-digitando span:nth-child(2) {
  animation-delay: 0.2s;
}

.assistente-digitando span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes assistente-pulso {

  0%,
  60%,
  100% {
    opacity: 0.3;
    transform: translateY(0);
  }

  30% {
    opacity: 1;
    transform: translateY(-3px);
  }
}

.assistente-rodape {
  display: flex;
  align-items: flex-end;
  padding: 10px;
  background-color: #fff;
  border-top: 1px solid #e0e0e0;
}

@media (max-width: 600px) {
  .assistente {
    right: 12px;
    bottom: 12px;
  }

  .assistente--deslocado {
    bottom: 92px;
  }

  .assistente-painel {
    height: calc(100vh - 150px);
  }
}
</style>
